import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LayoutFilledSvg from "@ant-design/icons-svg/es/asn/LayoutFilled";
import AntdIcon from "../components/AntdIcon";
var LayoutFilled = function LayoutFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LayoutFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LayoutFilled.displayName = 'LayoutFilled';
}
export default /*#__PURE__*/React.forwardRef(LayoutFilled);